<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editForm" ref="editForm" label-width="170px">
        <el-form-item class="addAdminForm" label="入库类别">
          <el-select v-model="editForm.zilei" placeholder="请选择">
            <el-option label="生产完工入库" value="101"></el-option>
            <el-option label="退货入库" value="105"></el-option>
            <el-option label="返修入库" value="102"></el-option>
            <el-option label="体验产品入库" value="103"></el-option>
            <el-option label="其他入库" value="104"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="产品名称">
          <el-select v-model="editForm.projectcode" placeholder="请选择" filterable>
            <el-option
              v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="日期">
          <el-date-picker v-model="editForm.riqi" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item class="addAdminForm" label="数量">
          <el-input v-model="editForm.num"></el-input>
        </el-form-item>
        <el-form-item label="备注(选填)" class="addAdminForm">
          <el-input v-model="editForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickSave">保存</el-button>
          <el-button type="info" @click="clickReturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      ProjectNameList:[],
      editForm: {
        id: 0,
        zilei: '',
        projectcode: '',
        riqi: '',
        num: '',
        beizhu: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row,ProjectNameList) {
      this.editForm.id = row.Id
      this.editForm.zilei = row.Zilei.toString()
      this.editForm.projectcode = row.Shangpincode
      this.editForm.riqi = row.Riqi
      this.editForm.num = row.Num
      this.editForm.beizhu = row.Beizhu
      this.ProjectNameList = ProjectNameList
    },
    clickReturn () {
      this.$emit('triggerFunc', '')
    },
    clickSave () {
      this.apiEditErp6InventoryIn()
    },
    apiEditErp6InventoryIn: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        zilei: that.editForm.zilei,
        projectcode: that.editForm.projectcode,
        riqi: that.editForm.riqi,
        num: that.editForm.num,
        beizhu: that.editForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp6InventoryIn, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
